var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.601452 12.2526C0.293835 12.5602 0.285046 13.0963 0.601452 13.4039C0.917858 13.7116 1.4452 13.7116 1.75282 13.4039L6.99989 8.15687L12.2382 13.4039C12.5546 13.7116 13.0819 13.7203 13.3895 13.4039C13.6972 13.0875 13.6972 12.5602 13.3895 12.2526L8.14247 7.0055L13.3895 1.76722C13.6972 1.45082 13.7059 0.923474 13.3895 0.615856C13.0731 0.308239 12.5546 0.308239 12.2382 0.615856L6.99989 5.86293L1.75282 0.615856C1.4452 0.308239 0.909069 0.29945 0.601452 0.615856C0.293835 0.932263 0.293835 1.45961 0.601452 1.75843L5.84852 7.0055L0.601452 12.2526Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.f8a338f9ef8c385f028ffeb022477988.svg";
export { ForwardRef as ReactComponent };